export const environment = {
  production: false,
  eOvrheApiUrl: 'https://e-ovrhe-test.tetralab.hr/api/',
  eKomunikacijaApiUrl: 'https://e-komunikacija-test.tetralab.hr/api/',
  legaleaseApiUrl: 'https://legalease-backend-test-mme8c.ondigitalocean.app',
};
